import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

export async function show(slug, loading = false) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  let material = {};

  await axios
    .get(`/materials/${slug}`)
    .then(async (response) => {
      material = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { material };
}
